import { render } from "./CrossNavigationManagementDocParameters.vue?vue&type=template&id=bc3b8e74&scoped=true&ts=true"
import script from "./CrossNavigationManagementDocParameters.vue?vue&type=script&lang=ts"
export * from "./CrossNavigationManagementDocParameters.vue?vue&type=script&lang=ts"

import "./CrossNavigationManagementDocParameters.vue?vue&type=style&index=0&id=bc3b8e74&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3b8e74"]])

export default __exports__